import { useTranslation } from "react-i18next"
import AccountGeneralSettingsForm from "features/account/accountGeneralSettingsForm"
import Section from "components/layout/section"
import PageTitle from "features/navigation/pageTitle"
import RightSidebar from "@/components/sidebar/right/RightSidebar"

const GeneralSettingsPage = () => {

    const { t } = useTranslation()

    return (
        <>
            <PageTitle title={t('titleGeneralSettings')} />
            <Section>
                <AccountGeneralSettingsForm />
            </Section>
            <RightSidebar />
        </>
    )
}

export default GeneralSettingsPage

